"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { ElementType, useMemo } from "react";
import Maybe from "../lib/Maybe";
import parseHighlighedText from "./parseHighlighedText";
const TextHighlight = t0 => {
  const $ = _c(13);
  const {
    children,
    className,
    inverted,
    serifClass,
    serif,
    as
  } = t0;
  let t1;
  bb0: {
    if (!children) {
      t1 = null;
      break bb0;
    }
    let t2;
    if ($[0] !== children || $[1] !== inverted || $[2] !== serif || $[3] !== serifClass) {
      const parsed = parseHighlighedText(children);
      let t3;
      if ($[5] !== inverted || $[6] !== serif || $[7] !== serifClass) {
        t3 = (part, index) => {
          if (part.type === "serif") {
            return <span key={part.text} className={clsx({
              "font-serif text-[108%] leading-[1]": serif,
              "text-primary-800": !serifClass && !inverted,
              "text-neutral-0": !serifClass && inverted
            }, serifClass)}>{part.text}</span>;
          } else {
            if (part.type === "break") {
              return <br key={index} />;
            }
          }
          return part.text;
        };
        $[5] = inverted;
        $[6] = serif;
        $[7] = serifClass;
        $[8] = t3;
      } else {
        t3 = $[8];
      }
      t2 = parsed.map(t3);
      $[0] = children;
      $[1] = inverted;
      $[2] = serif;
      $[3] = serifClass;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = t2;
  }
  const text = t1;
  const Component = as || "span";
  let t2;
  if ($[9] !== Component || $[10] !== className || $[11] !== text) {
    t2 = <Component className={className}>{text}</Component>;
    $[9] = Component;
    $[10] = className;
    $[11] = text;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
export default TextHighlight;